import { useEffect } from 'react';
import { useMap } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet.heat';

/**
 * Capa de mapa de calor (HU-010 Fase 5) — envuelve `leaflet.heat` (plugin
 * ligero, ya que Leaflet/react-leaflet están instalados en todo el
 * proyecto) como componente de `react-leaflet`: no hay wrapper oficial, así
 * que se agrega/quita la capa a mano sobre la instancia real del mapa
 * (`useMap`) cada vez que cambian los puntos, en vez de mantenerla montada
 * y mutar sus datos.
 */
const CapaMapaCalor = ({ puntos }) => {
  const map = useMap();

  useEffect(() => {
    if (!puntos || puntos.length === 0) return undefined;

    const capa = L.heatLayer(puntos, { radius: 22, blur: 18, maxZoom: 17 }).addTo(map);
    return () => { map.removeLayer(capa); };
  }, [map, puntos]);

  return null;
};

export default CapaMapaCalor;
